// @flow

import React, { Component } from 'react';

import { connect } from 'react-redux';
import { get, nth, includes } from 'lodash';

import DefaultLmis from './DefaultLmis/DefaultLmis';
import { trackedLinkClicked } from 'src/store/location/location';
import { lmisImpression } from 'src/store/lmis/lmis';
import { Card, Section } from 'seek-style-guide/react';
import TrackScrollToOnce from '../TrackScrollToOnce/TrackScrollToOnce';

type Props = {
  locale: Locale,
  lmisType?: string,
  lmisContextType?: string,
  content: string,
  showDefault?: boolean,
  trackedLinkClicked: Function,
  lmisImpression: Function
};

type GetPlacementIdFromFFOrExperimentProps = {
  experimentId: string,
  featureFlagKey: string,
  placementIds: Array<string>
};

export const getPlacementId = (
  experiment: string,
  placementIds: Array<string>
): Function => (experiments: Seek$Experiments): string =>
  nth(placementIds, get(experiments, `${experiment}.variation.index`));

export const getPlacementIdFromFFOrExperiment = (
  getState: Function,
  props: GetPlacementIdFromFFOrExperimentProps
): string => {
  const { experimentId, featureFlagKey, placementIds } = props;
  const { featureFlags, experiments } = getState();
  const featureFlag = get(featureFlags, featureFlagKey);
  const toPlacementId = getPlacementId(experimentId, placementIds);
  return includes(placementIds, featureFlag)
    ? featureFlag
    : toPlacementId(experiments);
};

const mapStateToProps = ({
  lmis: { lmisType, content, lmisContextType },
  location: { locale }
}) => {
  return {
    locale,
    lmisType,
    lmisContextType,
    content
  };
};

const createMarkup = html => {
  return {
    __html: html
  };
};

const mapDispatchToProps = {
  trackedLinkClicked,
  lmisImpression
};

class Lmis extends Component<Props> {
  static defaultProps = {
    showDefault: false
  };

  lmisLinkClicked = event => {
    const { href } = event.target;

    if (href) {
      this.props.trackedLinkClicked({
        analytics: 'lmis-clicked',
        href
      });
    }
  };

  lmisImpression = () => {
    this.props.lmisImpression({
      lmisType: this.props.lmisType,
      lmisContextType: this.props.lmisContextType
    });
  };

  render() {
    const { showDefault, locale, content } = this.props;

    if (!content && !showDefault) {
      return null;
    }

    return (
      <TrackScrollToOnce enterViewport={this.lmisImpression}>
        <Card>
          <Section>
            {content ? (
              <div
                dangerouslySetInnerHTML={createMarkup(content)} // eslint-disable-line react/no-danger
                data-automation="dynamic-lmis"
                onClick={this.lmisLinkClicked}
              />
            ) : (
              showDefault && <DefaultLmis {...{ locale }} />
            )}
          </Section>
        </Card>
      </TrackScrollToOnce>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Lmis);
